"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestTracking = exports.DAY_IN_MS = exports.TRACKING_ID = void 0;
const uuid_1 = require("uuid");
exports.TRACKING_ID = 'LoginRequestId';
exports.DAY_IN_MS = 864e5;
const requestTracking = (req, res) => {
    if (!req.cookies.get(exports.TRACKING_ID)) {
        /**
         * Cookie should only last a maximum of 1 day.
         */
        res.cookies.set(exports.TRACKING_ID, (0, uuid_1.v4)(), {
            sameSite: 'lax',
            maxAge: exports.DAY_IN_MS
        });
        return true;
    }
    res.cookies.set(exports.TRACKING_ID, req.cookies.get(exports.TRACKING_ID));
    return false;
};
exports.requestTracking = requestTracking;
exports.default = exports.requestTracking;
